module.exports = __webpack_public_path__ + "static/media/live26_09_2020.53dad864.jpeg";